// Auto-generated auditorium lists for frontend usage
export const AUDITORIES_BUILDING_1 = [
  "106",
  "107",
  "108",
  "109",
  "110",
  "111",
  "115",
  "116",
  "117",
  "207",
  "208",
  "209",
  "211",
  "212",
  "213",
  "214",
  "215",
  "307",
  "308",
  "310",
  "311",
  "313",
  "314",
  "316",
  "TREN",
];

export const AUDITORIES_BUILDING_2 = [
  "101",
  "105",
  "110",
  "201",
  "202",
  "203",
  "204",
  "211",
  "302",
  "304",
];

const auditoriesConst = {
  AUDITORIES_BUILDING_1,
  AUDITORIES_BUILDING_2,
};
export default auditoriesConst;